import React from "react";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

export default function SortIcon({ sort, field, params }) {
    if (sort == "asc" && params?.field == field) {
        return <ArrowUpwardIcon />;
    }
    else if (sort == "desc" && params?.field == field) {
        return <ArrowDownwardIcon />;
    }
    else {
        return <></>;
    }
}
